import { Center, Stack } from '@mantine/core';
import { isImpersonating } from '@repo/common/analytics/utils/isImpersonating';
import { api } from '@repo/common/utils/network';
import { Text } from '@repo/foundations';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { processAuthEvent } from '../../utils/crossTabAuth';
import { LoadingSpinner } from '../LoadingSpinner';

// Do not import this function directly, navigate to `AuthLogout` instead, because clearing the cache will cause null references to `user` in `useAuthUser`
async function logout(redirect?: string) {
	await fetch(
		isImpersonating()
			? `${api()}auth/utilities/terminate_impersonation/`
			: `${api()}auth/u/logout/`
	);

	processAuthEvent({
		type: isImpersonating() ? 'IMPERSONATION_END' : 'SIGN_OUT',
		redirectPath: redirect ?? '/',
	});
}

export function AuthLogout() {
	const { redirect: redirectParam } = useParams();

	// eslint-disable-next-line no-use-effect/no-use-effect
	useEffect(() => {
		logout(redirectParam);
	}, [redirectParam]);

	return (
		<Center h="100vh">
			<Stack>
				<Text color="text/primary/default" size="md">
					{isImpersonating() ? 'Stopping impersonation session' : 'Logging out'}
				</Text>
				<LoadingSpinner />
			</Stack>
		</Center>
	);
}

export default AuthLogout;
